import { h } from './lib/dom.js';

// A single persistent element appended once to <body>, outside the #app
// root that gets torn down and rebuilt on every render. Screen readers
// reliably announce aria-live regions only when their *content* changes on
// an element that was already in the DOM — a freshly inserted node (which
// is what the old render-time-created toast was, every single time) isn't
// guaranteed to be picked up.
let toastEl = null;

function ensureToastEl() {
  if (toastEl) return toastEl;
  toastEl = h('div', { class: 'toast', role: 'status', 'aria-live': 'polite' }, '');
  document.body.appendChild(toastEl);
  return toastEl;
}

export function updateToast(message) {
  const el = ensureToastEl();
  el.textContent = message || '';
  el.classList.toggle('visible', !!message);
}
